import React__default, { useState } from 'react';
import { Label, Input } from 'reactstrap';
import { Controller } from '../../../../../../node_modules/.pnpm/react-hook-form@7.22.0_react@19.0.0/node_modules/react-hook-form/dist/index.esm.mjs.js';
import { FontAwesomeIcon } from '../../../../../../node_modules/.pnpm/@fortawesome_react-fontawesome@0.2.2_@fortawesome_fontawesome-svg-core@6.7.2_react@19.0.0/node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faExclamationTriangle } from '../../../../../../node_modules/.pnpm/@fortawesome_free-solid-svg-icons@6.7.2/node_modules/@fortawesome/free-solid-svg-icons/index.mjs.js';
import { useFormContext } from '../Form.js';
import useConfig from '../../Hooks/useConfig.js';
import useAppService from '../../Hooks/useAppService.js';
import dayjs from 'dayjs';
import useMediaQuery, { MEDIAQUERY_DEFAULTS } from '../../Hooks/useMediaQuery.js';
import classNames from '../../../../../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js';
import { sanitize } from '@ibe/services';

const FormInput = (props) => {
    const { id, tag, name, baseName, label, boldLabel, className, errorsProp, type, autoComplete, disabled, placeholder, showErrors, showErrorIcon, disablePaste, onFocus, onBlur, ignoreTypeSwitchInMobile, ignoreTypeSwitchInDesktop, customCheckboxElement } = props;
    const config = useConfig();
    const app = useAppService();
    const { register, errors, control } = useFormContext();
    const [isDateField, setIsDateField] = useState(false);
    const isDesktop = useMediaQuery({ type: 'min', query: MEDIAQUERY_DEFAULTS.md });
    const elementId = `form-builder-input-${id || name}-${tag}`;
    if (!register)
        return null;
    const formErrors = errorsProp || errors;
    const handleFocus = (e) => {
        if (tag === 'dateInput') {
            setIsDateField(true);
        }
        if (!!onFocus) {
            onFocus(e);
        }
    };
    const handleBlur = (e) => {
        if (tag === 'dateInput') {
            setIsDateField(false);
        }
        if (!!onBlur) {
            onBlur(e);
        }
    };
    const getValue = (value) => {
        if (tag === 'dateInput' &&
            !isDateField &&
            !!value &&
            (!ignoreTypeSwitchInMobile || (ignoreTypeSwitchInMobile && isDesktop)) &&
            (!ignoreTypeSwitchInDesktop || (ignoreTypeSwitchInDesktop && !isDesktop))) {
            return dayjs(value).format(config.displayFormatDate[app.lang]);
        }
        else {
            return value;
        }
    };
    const renderInput = (field) => {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Input, { id: elementId, ...field, "data-testid": 'form-input-' + name, value: getValue(field.value), type: isDateField ||
                    (tag === 'dateInput' &&
                        ((ignoreTypeSwitchInMobile && !isDesktop) ||
                            (ignoreTypeSwitchInDesktop && isDesktop)))
                    ? 'date'
                    : type || 'text', onFocus: handleFocus, onBlur: handleBlur, className: `${className || ''} ${!!field.value ? 'input--filled' : ''} ${!!customCheckboxElement ? 'input--hidden' : ''}`, autoComplete: autoComplete, disabled: disabled, placeholder: placeholder, onPaste: (e) => {
                    if (disablePaste) {
                        e.preventDefault();
                    }
                } }),
            !!customCheckboxElement && customCheckboxElement));
    };
    return (React__default.createElement("div", { className: classNames('form-input', {
            'input--error': formErrors && showErrors && formErrors[baseName || name]
        }) },
        !!label && !customCheckboxElement && (React__default.createElement(Label, { className: `${formErrors && showErrors && formErrors[baseName || name] ? 'form__error__top' : ''}${boldLabel ? ' font-weight-bold' : ''}`, htmlFor: elementId, dangerouslySetInnerHTML: { __html: sanitize(label, true) } })),
        React__default.createElement(Controller, { name: name, control: control, render: ({ field }) => tag !== 'dateInput' ? (React__default.createElement(React__default.Fragment, null, type === 'checkbox' && !!customCheckboxElement && !!label ? (React__default.createElement(Label, { className: `custom-checkbox-label ${formErrors && showErrors && formErrors[baseName || name]
                    ? 'form__error__top'
                    : ''}${boldLabel ? ' font-weight-bold' : ''}`, htmlFor: elementId },
                React__default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: sanitize(label, true)
                    } }),
                renderInput(field))) : (renderInput(field)))) : (React__default.createElement("div", { className: "position-relative" },
                renderInput(field),
                tag === 'dateInput' &&
                    ((ignoreTypeSwitchInMobile && !isDesktop) ||
                        (ignoreTypeSwitchInDesktop && isDesktop)) &&
                    !isDateField &&
                    !field.value &&
                    !!placeholder && (React__default.createElement("div", { className: "form__input__placeholder", onClick: () => {
                        setIsDateField(true);
                        document.getElementById(elementId)?.focus();
                        document.getElementById(elementId)?.click();
                    } }, placeholder)))) }),
        formErrors && showErrors
            ? formErrors[baseName || name] && (React__default.createElement("div", { className: "form__error" }, formErrors[baseName || name].message))
            : null,
        showErrorIcon && formErrors && showErrors && formErrors[baseName || name] && (React__default.createElement(FontAwesomeIcon, { icon: faExclamationTriangle }))));
};

export { FormInput as default };
//# sourceMappingURL=FormInput.js.map
